<template>
  <div class="queue-cleint">
    <div class="queue-cleint__block">
      <h2 class="queue-cleint__label">Minha senha</h2>
      <p class="queue-cleint__number">{{ number }}</p>
    </div>
    <div class="queue-cleint__current">
      <div class="queue-cleint__block">
        <h2 class="queue-cleint__label">Senha normal<br>atual</h2>
        <p class="queue-cleint__current-number">{{ CurrentClienteNormal }}</p>
      </div>
      <div class="queue-cleint__block">
        <h2 class="queue-cleint__label">Senha preferencial<br>atual</h2>
        <p class="queue-cleint__current-number">{{ CurrentClientePreferencial }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import socket from '../../socket/index.js'

export default {
  name: 'QueueCleint',
  computed: {
    ...mapGetters(['station', 'CurrentClienteNormal', 'CurrentClientePreferencial']),
    number () {
      return this.$route.params.number
    }
  },
  async created () {
    await this.fetchStation({
      accountName: this.$route.params.account,
      stationName: this.$route.params.station
    })

    socket.emit('joinStation', this.station.id)
    socket.on('stationUpdated', this.handleStationUpdated)
  },
  beforeUnmount () {
    socket.off('stationUpdated', this.handleStationUpdated)
  },
  methods: {
    ...mapActions(['fetchStation']),
    handleStationUpdated (station) {
      this.$store.commit('SET_STATION', station)
    }
  }
}
</script>

<style scoped>
.queue-cleint {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 64px;
  min-height: 100vh;
}

.queue-cleint__current {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 48px;
}

.queue-cleint__block {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.queue-cleint__label {
  font-size: 3rem;
  margin: 0;
  text-align: center;
  line-height: 1.2;
}

.queue-cleint__number {
  font-size: 10rem;
  font-weight: bold;
  margin: 0;
}

.queue-cleint__current-number {
  font-size: 5rem;
  font-weight: bold;
  margin: 0;
}
</style>
